// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Irrigation System Monitoring - Figma Design Match
 * Colors and typography from Figma design tokens
 */

/* ========================================
   COLORS FROM FIGMA
   ======================================== */
:root {
  --grey-100: #ffffff;
  --grey-98: #f6f8fa;
  --grey-96: #eef1f6;
  --grey-91: #dce0e8;
  --grey-80: #afb9cc;
  --grey-71: #919db4;
  --grey-52: #626e84;
  --grey-45: #4d5674;
  --grey-34: #3b4259;
  --grey-25: #2a2f40;

  --primary-idle: #4563c7;
  --status-alert: #df3044;
  --status-warning: #ffb302;
  --status-positive: #078378;
  --event-irrigation: #0a5ef0;

  /* Typography */
  --font-family: 'Source Sans Pro', sans-serif;
}

/* ========================================
   LAYOUT
   ======================================== */
.irrigation-monitoring {
  display: flex;
  gap: 40px;
  height: calc(100vh - 48px);
  background-color: #eef1f6;
  padding: 8px 40px 40px 40px;
  overflow-x: hidden;
}

/* ========================================
   LEFT PANEL - FIELD LIST
   ======================================== */
.leading-panel {
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;
  overflow: hidden;
  background: transparent;
}

.leading-panel.basic {
  width: 400px;
  min-width: 400px;
  max-width: 400px;
}

.leading-panel.advanced {
  flex: 1 1 auto;
  min-width: 400px;
  max-width: 1200px;
  overflow: hidden;
}

/* In advanced mode, map takes remaining space with min-width constraint */
.leading-panel.advanced + .trailing-panel-wrap {
  flex: 1;
  min-width: 520px;
}

/* ========================================
   SELECTORS (Sort and Advanced/Close buttons)
   ======================================== */
.selectors {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 0px;
  gap: 16px;
  background: transparent;
  font-family: 'Source Sans Pro', sans-serif;
  font-family: var(--font-family);
  font-size: 14px;
  line-height: 16px;
  color: #3b4259;
  color: var(--grey-34);
  box-sizing: border-box;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  z-index: 2;
  position: relative;
}

/* Sort button */
.sort-button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  height: 40px;
  padding: 4px 12px 4px 8px;
  background-color: transparent;
  border: none;
  border-radius: 16px;
  cursor: pointer;
  font-family: 'Source Sans Pro', sans-serif;
  font-family: var(--font-family);
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
  color: #626e84;
  color: var(--grey-52);
  transition: background-color 0.2s;
  flex: none;
}

.sort-button:hover {
  background-color: #eef1f6;
  background-color: var(--grey-96);
}

.selector-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

/* All Farm - Sort dropdown (Figma) */
.all-farm-sort {
  position: relative;
  display: flex;
  align-items: center;
}

.all-farm-sort__button {
  /* data manipulator */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 4px 12px 4px 8px;
  gap: 4px;
  width: 92px;
  height: 40px;
  background: transparent;
  border: none;
  border-radius: 16px;
  cursor: pointer;
  color: var(--color-grey-45);
  color: var(--color-grey-45);
}

.all-farm-sort__button:hover {
  background: var(--color-grey-91);
  background: var(--color-grey-91);
}

.all-farm-sort__button:active {
  background: var(--color-grey-80);
  background: var(--color-grey-80);
}

/* Crop water availability (Figma: active=off): grey shades */
.all-farm-sort__button--crop-availability:hover {
  background: var(--color-grey-91);
  background: var(--color-grey-91);
}

.all-farm-sort__button--crop-availability:active {
  background: var(--color-grey-80);
  background: var(--color-grey-80);
}

/* After click (menu open): crop availability keeps hover appearance when mouse leaves */
.all-farm-sort__button--open.all-farm-sort__button--crop-availability {
  background: var(--color-grey-91);
  background: var(--color-grey-91);
  color: var(--color-grey-45);
  color: var(--color-grey-45);
}

.all-farm-sort__button--open.all-farm-sort__button--crop-availability:hover {
  background: var(--color-grey-91);
  background: var(--color-grey-91);
}

.all-farm-sort__button--open.all-farm-sort__button--crop-availability:active {
  background: var(--color-grey-80);
  background: var(--color-grey-80);
}

/* Non-crop-availability sort (Figma: active=on): blue shades */
.all-farm-sort__button--active {
  background: #dbeafe;
  color: #1d4ed8;
}

.all-farm-sort__button--active:hover {
  background: #bdd5ff;
}

.all-farm-sort__button--active:active {
  background: #a8c8ff;
}

/* After click (menu open): non-crop keeps hover appearance when mouse leaves */
.all-farm-sort__button--open.all-farm-sort__button--active {
  background: #bdd5ff;
}

.all-farm-sort__button--open.all-farm-sort__button--active:hover {
  background: #bdd5ff;
}

.all-farm-sort__button--open.all-farm-sort__button--active:active {
  background: #a8c8ff;
}

.all-farm-sort__menu {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  min-width: 240px;
  background: var(--color-grey-100);
  background: var(--color-grey-100);
  border: 1px solid var(--color-grey-91);
  border: 1px solid var(--color-grey-91);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  padding: 8px;
  z-index: 1000;
}

.all-farm-sort__menu-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 10px 8px;
  background: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  color: var(--color-grey-45);
  color: var(--color-grey-45);
  text-align: left;
}

.all-farm-sort__menu-item:hover {
  background: var(--color-grey-96);
  background: var(--color-grey-96);
}

.all-farm-sort__menu-item--selected {
  background: var(--color-grey-98);
  background: var(--color-grey-98);
}

.all-farm-sort__menu-item-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.all-farm-sort__menu-check {
  width: 16px;
  height: 16px;
  color: var(--color-grey-45);
  color: var(--color-grey-45);
  opacity: 0;
}

.all-farm-sort__menu-check--visible {
  opacity: 1;
}

.all-farm-sort__menu-item-label {
  color: inherit;
}

/* Sort and Group buttons container */
.sort-and-group-wrap {
  display: flex;
  gap: 8px;
  align-items: center;
}

/* Individual selector item (Sort, Group) */
.selector-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-family: 'Source Sans Pro', sans-serif;
  font-family: var(--font-family);
  font-size: 14px;
  font-weight: 600;
  color: #626e84;
  color: var(--grey-52);
  transition: background-color 0.2s;
}

.selector-item:hover {
  background-color: #eef1f6;
  background-color: var(--grey-96);
}

.selector-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

/* Advanced/Close button */
.button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 40px;
  padding-left: 22px;
  padding-right: 16px;
  background-color: transparent;
  border: 1px solid #919db4;
  border: 1px solid var(--grey-71);
  border-radius: 16px;
  cursor: pointer;
  font-family: 'Source Sans Pro', sans-serif;
  font-family: var(--font-family);
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
  color: #4d5674;
  color: var(--grey-45);
  text-decoration: none;
  transition: all 0.2s;
  white-space: nowrap;
  flex: none;
  overflow: hidden;
  max-width: 100%;
}

.button.minimized {
  background-color: transparent;
  border-color: #919db4;
  border-color: var(--grey-71);
  color: #4d5674;
  color: var(--grey-45);
  padding-left: 22px;
  padding-right: 16px;
}

.button.expanded {
  background-color: transparent;
  border: 1px solid #919db4;
  border: 1px solid var(--grey-71);
  color: #4d5674;
  color: var(--grey-45);
  padding: 0px 24px 0px 16px;
  width: 98px;
}

.button:hover {
  background-color: var(--color-grey-98);
  background-color: var(--color-grey-98);
}

.button:active {
  background-color: var(--color-grey-91);
  background-color: var(--color-grey-91);
}

.button svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

/* DEPRECATED: Old classes - kept for backward compatibility */
.header-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  background-color: transparent;
}

.sort-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-family: 'Source Sans Pro', sans-serif;
  font-family: var(--font-family);
  font-size: 14px;
  font-weight: 600;
  color: #626e84;
  color: var(--grey-52);
  transition: background-color 0.2s;
}

.sort-button:hover {
  background-color: #eef1f6;
  background-color: var(--grey-96);
}

.sort-button svg {
  width: 20px;
  height: 20px;
  stroke: #626e84;
  stroke: var(--grey-52);
}

.toggle-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: transparent;
  border: 1px solid #dce0e8;
  border: 1px solid var(--grey-91);
  border-radius: 4px;
  cursor: pointer;
  font-family: 'Source Sans Pro', sans-serif;
  font-family: var(--font-family);
  font-size: 14px;
  font-weight: 600;
  color: #4d5674;
  color: var(--grey-45);
  transition: all 0.2s;
  min-width: 100px;
  justify-content: center;
}

.toggle-button:hover {
  background-color: #eef1f6;
  background-color: var(--grey-96);
  border-color: #afb9cc;
  border-color: var(--grey-80);
}

.toggle-button.advanced-mode {
  background-color: #ffffff;
  background-color: var(--grey-100);
  border-color: #dce0e8;
  border-color: var(--grey-91);
  color: #4d5674;
  color: var(--grey-45);
}

.toggle-button.close-mode {
  background-color: #df3044;
  background-color: var(--status-alert);
  border-color: #df3044;
  border-color: var(--status-alert);
  color: #ffffff;
  color: var(--grey-100);
}

.toggle-button.close-mode:hover {
  background-color: #c72838;
  border-color: #c72838;
}

.toggle-button svg {
  width: 16px;
  height: 16px;
}

.button.close-mode {
  background-color: #df3044;
  background-color: var(--status-alert);
  border-color: #df3044;
  border-color: var(--status-alert);
  color: #ffffff;
  color: var(--grey-100);
}

.button.close-mode:hover {
  background-color: #c72838;
  border-color: #c72838;
}

/* ========================================
   DEPRECATED SECTIONS (kept for reference)
   ======================================== */
/* Location Breadcrumbs - REMOVED */
/* Selectors (Sort/Group) - REMOVED */

/* ========================================
   ACTION BAR (DEPRECATED - kept for compatibility)
   ======================================== */
.table-action-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
}

.data-manipulators {
  display: flex;
  gap: 8px;
}

.data-manipulator {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px 4px 12px;
  background: transparent;
  border: none;
  border-radius: 16px;
  cursor: pointer;
  font-family: 'Source Sans Pro', sans-serif;
  font-family: var(--font-family);
  font-size: 16px;
  font-weight: 600;
  color: #626e84;
  color: var(--grey-52);
  transition: background-color 0.2s;
}

.data-manipulator:hover {
  background-color: var(--color-grey-98);
  background-color: var(--color-grey-98);
}

.advanced-toggle-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 40px;
  padding: 0 16px;
  background: transparent;
  border: 1px solid #919db4;
  border: 1px solid var(--grey-71);
  border-radius: 16px;
  cursor: pointer;
  font-family: 'Source Sans Pro', sans-serif;
  font-family: var(--font-family);
  font-size: 16px;
  font-weight: 600;
  color: #4d5674;
  color: var(--grey-45);
  transition: all 0.2s;
}

.advanced-toggle-button:hover {
  background-color: var(--color-grey-98);
  background-color: var(--color-grey-98);
}

.advanced-toggle-button.advanced-mode {
  padding-left: 24px;
}

.advanced-toggle-button.close-mode {
  padding-right: 24px;
}

/* ========================================
   TABLE
   ======================================== */
.fields-table {
  display: flex;
  flex-direction: column;
  flex: 1;
  background: #ffffff;
  background: var(--grey-100);
  border: 1px solid #dce0e8;
  border: 1px solid var(--grey-91);
  border-radius: 16px;
  overflow: hidden;
  min-height: 0;
}

/* Scroll wrapper - handles horizontal scrolling in advanced mode */
.fields-table-scroll {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

/* In advanced mode, enable horizontal scrolling inside the table */
.leading-panel.advanced .fields-table-scroll {
  overflow-x: auto;
  min-width: 0;
}

/* Minimum width to display all advanced mode columns without wrapping:
   trigger-area (48px) + basic-section (328px) + gap (24px) + advanced-section (611px) ≈ 1016px */
.leading-panel.advanced .fields-table-scroll > * {
  min-width: 1016px;
}

/* ========================================
   TABLE HEADER
   ======================================== */
.table-header {
  display: flex;
  align-items: center;
  gap: 24px;
  height: 72px;
  padding: 0px 16px 0px 48px;
  background: #ffffff;
  background: var(--grey-100);
  border-bottom: 1px solid #dce0e8;
  border-bottom: 1px solid var(--grey-91);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  font-family: 'Source Sans Pro', sans-serif;
  font-family: var(--font-family);
  font-size: 14px;
  font-weight: 600;
  color: #3b4259;
  color: var(--grey-34);
  line-height: 16px;
  overflow: visible;
  position: relative;
  z-index: 1;
}

.basic-columns {
  display: flex;
  gap: 16px;
  align-items: center;
  flex: 1;
}

.advanced-columns {
  display: flex;
  flex: 1;
  gap: 40px;
  align-items: center;
}

.header-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.field-name-header {
  width: 216px;
}

.status-header {
  width: 96px;
}

.recommendation-header {
  width: 120px;
}

.performance-header {
  flex: 1;
  min-width: 120px;
  justify-content: flex-start;
}

.performance-header > span {
  flex: 0 0 auto;
  max-width: 80px;
  word-wrap: break-word;
  text-align: left;
}

.cbar-header > span {
  flex: 0 0 auto;
  max-width: 60px;
  word-wrap: break-word;
  text-align: left;
}

.irrigation-header {
  width: 112px;
}

.irrigation-header > span {
  flex: 0 0 auto;
  max-width: 65px;
  word-wrap: break-word;
  text-align: left;
}

.cbar-header {
  flex: 1;
  min-width: 160px;
}

.info-icon {
  flex-shrink: 0;
}

/* Info icon tooltip wrapper */
.info-icon-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}

.info-tooltip {
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background-color: #4d5674;
  background-color: var(--grey-45);
  color: #ffffff;
  color: var(--grey-100);
  padding: 5px 8px;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  width: 240px;
  white-space: normal;
  text-align: left;
  z-index: 99999;
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 0.2s,
    visibility 0.2s;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  pointer-events: none;
}

.info-tooltip::before {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 6px;
  border-style: solid;
  border-color: transparent transparent #4d5674 transparent;
  border-color: transparent transparent var(--grey-45) transparent;
}

.info-icon-wrapper:hover .info-tooltip {
  opacity: 1;
  visibility: visible;
}

/* Clock icon tooltip wrapper for transmitter update */
.clock-icon-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}

.clock-tooltip {
  position: absolute;
  bottom: calc(100% + 8px);
  right: 50%;
  transform: translateX(50%);
  background-color: #4d5674;
  background-color: var(--grey-45);
  color: #ffffff;
  color: var(--grey-100);
  padding: 6px 10px;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  white-space: nowrap;
  text-align: center;
  z-index: 99999;
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 0.2s,
    visibility 0.2s;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  pointer-events: none;
}

.clock-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 6px;
  border-style: solid;
  border-color: #4d5674 transparent transparent transparent;
  border-color: var(--grey-45) transparent transparent transparent;
}

.clock-icon-wrapper:hover .clock-tooltip {
  opacity: 1;
  visibility: visible;
}

/* ========================================
   FIELD LIST
   ======================================== */
.field-list {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  min-height: 0;
}

/* Custom scrollbar styling - hidden by default, visible on hover */
.field-list::-webkit-scrollbar {
  width: 8px;
}

.field-list::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 4px;
}

.field-list::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 4px;
  border: 2px solid transparent;
  background-clip: padding-box;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}

/* Show scrollbar on hover */
.field-list:hover::-webkit-scrollbar-thumb {
  background-color: #afb9cc;
  background-color: var(--grey-80);
}

.field-list::-webkit-scrollbar-thumb:hover {
  background-color: #919db4;
  background-color: var(--grey-71);
}

/* Firefox scrollbar styling - always visible (Firefox doesn't support hover-based scrollbar color changes) */
.field-list {
  scrollbar-width: thin;
  scrollbar-color: #afb9cc transparent;
  scrollbar-color: var(--grey-80) transparent;
}

/* ========================================
   FIELD ROW
   ======================================== */
.field-row {
  position: relative;
  display: flex;
  align-items: center;
  height: 88px;
  min-height: 88px;
  padding: 16px 0;
  background: #ffffff;
  background: var(--grey-100);
  border-bottom: 1px solid #dce0e8;
  border-bottom: 1px solid var(--grey-91);
  cursor: pointer;
  transition: background-color 0.2s;
}

.field-row:hover {
  background-color: var(--color-grey-98);
  background-color: var(--color-grey-98);
}

.field-row.selected {
  background-color: #f0f4ff;
  outline: 2px solid var(--color-primary-idel);
  outline: 2px solid var(--color-primary-idel);
  outline-offset: -2px;
  border-radius: 8px;
}

/* Field row settings menu on hover */
.field-row-settings {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 4px;
  pointer-events: auto;
}

.field-row-settings .dropdown {
  position: relative;
  z-index: 1;
}

.field-row-settings__icon {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
  background: linear-gradient(90deg, rgba(246, 248, 250, 0) 0%, #f6f8fa 37.5%);
}

.field-row-settings__icon:hover {
  background-color: var(--color-grey-96);
  background-color: var(--color-grey-96);
}

.field-row-settings__icon:active {
  background-color: var(--color-grey-91);
  background-color: var(--color-grey-91);
}

.field-row-settings__menu-portal {
  position: fixed;
  top: var(--menu-top);
  top: var(--menu-top);
  left: var(--menu-left);
  left: var(--menu-left);
  z-index: 1000;
}

/* Alert trigger area */
.trigger-area {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  flex-shrink: 0;
}

.alert-icon {
}

/* Main content */
.main-content {
  display: flex;
  flex: 1;
  gap: 24px;
  align-items: stretch;
}

/* ========================================
   BASIC SECTION (always visible)
   ======================================== */
.basic-section {
  display: flex;
  gap: 16px;
  align-items: center;
  flex: 1;
}

.name-and-crop {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 216px;
  font-family: 'Source Sans Pro', sans-serif;
  font-family: var(--font-family);
  color: #3b4259;
  color: var(--grey-34);
  line-height: 16px;
}

.field-name {
  font-size: 16px;
  font-weight: 700;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  line-height: 1.3;
  max-height: calc(1.3em * 2);
}

.crop-type {
  font-size: 14px;
  font-weight: 400;
}

.status-wrap {
  display: flex;
  align-items: center;
  width: 96px;
}

.crop-water-availability-status {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  padding: 4px 6px;
  border-radius: 4px;
  font-family: 'Source Sans Pro', sans-serif;
  font-family: var(--font-family);
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
}

/* Hide advanced sections in basic mode */
.table-header.basic .advanced-columns {
  display: none;
}

.field-row:not(.advanced-mode) {
  overflow: hidden;
}

.field-row:not(.advanced-mode) .advanced-section {
  visibility: hidden;
  position: absolute;
  pointer-events: none;
}

/* ========================================
   ADVANCED SECTION
   ======================================== */
.advanced-section {
  display: flex;
  flex: 1;
  gap: 40px;
  align-items: center;
  width: 611px;
}

/* In advanced mode, field row has specific sizing */
.field-row.advanced-mode {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 16px 16px 0px;
  width: auto;
  height: 88px;
  min-height: 88px;
  background: #ffffff;
  background: var(--grey-100);
  border-bottom: 1px solid #dce0e8;
  border-bottom: 1px solid var(--grey-91);
  border-radius: 0px;
  flex: none;
  align-self: stretch;
  flex-grow: 0;
}

.field-row.advanced-mode:hover {
  background-color: var(--color-grey-98);
  background-color: var(--color-grey-98);
}

.field-row.advanced-mode.selected {
  background-color: #f0f4ff;
  outline: 2px solid var(--color-primary-idel);
  outline: 2px solid var(--color-primary-idel);
  outline-offset: -2px;
  border-radius: 8px;
}

/* In advanced mode, basic section has fixed width */
.field-row.advanced-mode .basic-section {
  width: 328px;
  flex: none;
}

.table-header.advanced .basic-columns {
  width: 328px;
  flex: none;
}

.table-header.advanced .advanced-columns {
  width: 611px;
}

.cell {
  display: flex;
  align-items: center;
  font-family: 'Source Sans Pro', sans-serif;
  font-family: var(--font-family);
  font-size: 14px;
  font-weight: 600;
  color: #3b4259;
  color: var(--grey-34);
  line-height: 16px;
}

/* Recommendation Cell */
.recommendation-cell {
  width: 120px;
  padding: 8px 8px 8px 0;
}

.recommendation-amount .value-with-unit,
.actual-value .value-with-unit,
.planned-value .value-with-unit {
  display: inline-flex;
  align-items: flex-end;
  height: 16px;
  gap: 1px;
}

.value-with-unit .unit-wrap {
  height: 14px;
  display: flex;
  align-items: flex-end;
}

.value-with-unit .unit-wrap--inch {
  align-items: center;
}

.value-with-unit .unit--inch {
  transform: translateY(-1px);
}

.recommendation-amount .value,
.actual-value .value,
.planned-value .value {
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
}

.recommendation-amount .value,
.actual-value .value {
  color: #3b4259;
  color: var(--grey-34);
}

.recommendation-amount .unit,
.actual-value .unit,
.planned-value .unit {
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
}

.recommendation-amount .unit,
.actual-value .unit {
  color: #3b4259;
  color: var(--grey-34);
}

.recommendation-amount .frequency {
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  color: #3b4259;
  color: var(--grey-34);
}

/* Performance Cell */
.performance-cell {
  flex: 1;
  min-width: 120px;
}

/* Not available text for fields without weekly planner support */
.not-available-text {
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0%;
  color: var(--color-disabled-64);
  color: var(--color-disabled-64);
}

.performance-indicator {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  height: 56px;
  justify-content: center;
  position: relative;
}

.actual-value {
  display: flex;
  align-items: flex-end;
  gap: 1px;
  width: 53px;
}

.rail {
  display: flex;
  height: 8px;
  width: 100%;
  background-color: #dce0e8;
  background-color: var(--grey-91);
  border-radius: 24px;
  overflow: hidden;
}

.actual-indicator {
  height: 100%;
  background-color: #3b4259;
  background-color: var(--grey-34);
  border-radius: 80px;
  transition: width 0.3s ease;
}

.planned-wrap {
  position: absolute;
  left: 75%;
  bottom: 14px;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  height: 28px;
}

.planned-value {
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.planned-value .value {
  color: #626e84;
  color: var(--grey-52);
}

.planned-value .unit {
  color: #626e84;
  color: var(--grey-52);
}

.planned-indicator {
  width: 2px;
  flex: 1;
  background-color: #919db4;
  background-color: var(--grey-71);
}

/* Irrigation Cell */
.irrigation-cell {
  width: 112px;
  gap: 5px;
  padding: 2px 0;
}

.irrigation-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.irrigation-time {
  font-size: 14px;
  font-weight: 600;
  color: #3b4259;
  color: var(--grey-34);
}

.irrigation-duration {
  font-size: 12px;
  font-weight: 400;
  color: var(--grey-62);
  color: var(--grey-62);
}

.active-irrigation-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px 4px 8px;
  background-color: #0a5ef0;
  background-color: var(--event-irrigation);
  border-radius: 24px;
  font-size: 12px;
  font-weight: 600;
  color: #ffffff;
  color: var(--grey-100);
  line-height: 12px;
  width: -moz-fit-content;
  width: fit-content;
}

.irrigation-status-blinker {
  display: flex;
  align-items: center;
  justify-content: center;
}

.irrigation-status-blinker .indicator {
  width: 8px;
  height: 8px;
  background-color: #ffffff;
  background-color: var(--grey-100);
  border-radius: 50%;
  animation: blink 1.5s infinite;
}

@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}

.time-icon {
  flex-shrink: 0;
}

/* CBar Cell */
.cbar-cell {
  flex: 1;
  min-width: 160px;
}

.cbar-content {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
  overflow: hidden;
}

.cbar-graph-wrap {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.water-potential-graph {
  height: 40px;
}

.start-date {
  font-size: 12px;
  font-weight: 600;
  color: #626e84;
  color: var(--grey-52);
  line-height: 12px;
}

.current-cbar {
  font-size: 14px;
  font-weight: 600;
  color: #3b4259;
  color: var(--grey-34);
  text-align: right;
  width: 24px;
}

.cbar-no-data {
  font-size: 14px;
  font-weight: 500;
  color: #919db4;
  color: var(--grey-71);
  text-align: left;
  width: 100%;
}

/* ========================================
   RIGHT PANEL - MAP
   ======================================== */
/* Wrapper hosts the toggle (sits above the white frame) and the panel.
   Mirrors the leading-panel's 40px header + 8px gap so the white
   frames on both sides start at the same Y position. */
.trailing-panel-wrap {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 400px;
  height: 100%;
  gap: 8px;
}

.trailing-panel {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 400px;
  height: 100%;
  background: #ffffff;
  background: var(--grey-100);
  border: 1px solid #dce0e8;
  border: 1px solid var(--grey-91);
  border-radius: 16px;
  overflow: hidden;
  padding: 40px;
  gap: 16px;
}

/* Farm map / Field details segmented control */
.trailing-panel__tabs {
  box-sizing: border-box;
  /* Two equal columns sized by the longer label: 240px (Figma) in English,
     wider for longer translations (e.g. pt "Detalhes do campo") instead of
     overflowing. */
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-self: center;
  align-items: center;
  gap: 2px;
  width: -moz-max-content;
  width: max-content;
  min-width: 240px;
  max-width: 100%;
  height: 40px;
  padding: 4px;
  background: #ffffff;
  border: 1px solid #dce0e8;
  border: 1px solid var(--color-grey-91, #dce0e8);
  border-radius: 16px;
  flex: none;
}

.trailing-panel__tab {
  flex: 1;
  height: 32px;
  padding: 8px 12px;
  border: none;
  border-radius: 12px;
  background: transparent;
  color: #4d5674;
  color: var(--color-grey-45, #4d5674);
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  white-space: nowrap;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    color 0.15s ease;
}

.trailing-panel__tab:hover:not(.trailing-panel__tab--selected) {
  background: #eef1f6;
  background: var(--color-grey-96, #eef1f6);
}

.trailing-panel__tab--selected {
  background: #4d5674;
  background: var(--color-grey-45, #4d5674);
  color: #ffffff;
}

.trailing-panel__details {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: auto;
  position: relative;
  z-index: 0;
  background: transparent;
}

.trailing-panel__details-empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px;
  color: #919db4;
  color: var(--color-grey-71, #919db4);
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

.map-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border: 1px solid #dce0e8;
  border: 1px solid var(--grey-91);
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  z-index: 0;
}

/* Hide NDVI timeline/legend by default - only show when explicitly on */
.map-container .map-legend {
  display: none !important;
}

.map-container.ndvi-on .map-legend {
  display: block !important;
}

/* Show map control buttons (zoom, home, layers) - always visible */
.map-container .leaflet-control-container .map-legend {
  display: block !important;
}

/* Override Leaflet default 10px margin to 8px for map controls */
.map-container .leaflet-top .leaflet-control {
  margin-top: 8px;
}
.map-container .leaflet-bottom .leaflet-control {
  margin-bottom: 8px;
}
.map-container .leaflet-left .leaflet-control {
  margin-left: 8px;
}
.map-container .leaflet-right .leaflet-control {
  margin-right: 8px;
}

/* ========================================
   RESPONSIVE
   ======================================== */
@media (max-width: 1439px) {
  .irrigation-monitoring {
    gap: 24px;
    padding: 8px 24px 24px 24px;
  }
}

/* ========================================
   ALERT TOOLTIP
   ======================================== */
.alert-tooltip {
  position: fixed;
  background: #ffffff;
  background: var(--grey-100);
  border-radius: 10px;
  border: 1px solid #dce0e8;
  border: 1px solid var(--grey-91);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
  z-index: 1001;
  width: 380px;
  max-height: 480px;
  overflow: visible;
}

/* Arrow border (grey-91) */
.alert-tooltip::before {
  content: '';
  position: absolute;
  top: 50%;
  top: var(--arrow-top, 50%);
  left: -16px;
  transform: translateY(-50%);
  width: 16px;
  height: 24px;
  background: #dce0e8;
  background: var(--grey-91);
  clip-path: polygon(100% 0, 0 50%, 100% 100%);
}

/* Arrow fill (white, inset by 1px to reveal border) */
.alert-tooltip::after {
  content: '';
  position: absolute;
  top: 50%;
  top: var(--arrow-top, 50%);
  left: -14px;
  transform: translateY(-50%);
  width: 14px;
  height: 22px;
  background: #ffffff;
  background: var(--grey-100);
  clip-path: polygon(100% 0, 0 50%, 100% 100%);
}

.alert-tooltip-list {
  overflow-y: auto;
  max-height: 480px;
  padding: 24px;
  border-radius: 10px;
}

/* Constrain NotificationItem content inside tooltip */
.alert-tooltip-list .alert_div {
  overflow: hidden;
}

.alert-tooltip-list .alert_div:last-child {
  border-bottom: none !important;
}

.alert-tooltip-list .alert_div > div:last-child {
  overflow: hidden;
  min-width: 0;
  flex: 1;
}

.alert-tooltip-list .read-more-pill {
  flex-shrink: 0;
}

/* Field details tab: the tab lays itself out (header + scrolling body), so
   the panel drops the map tab's padding. */
.trailing-panel.trailing-panel--details {
  padding: 0;
  gap: 0;
}

.trailing-panel--details .trailing-panel__details {
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./app/components/dashboard/AllFarmView/IrrigationSystemMonitoring.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;;6CAE6C;AAC7C;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;;EAElB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;;EAE3B,eAAe;EACf,4CAA4C;AAC9C;;AAEA;;6CAE6C;AAC7C;EACE,aAAa;EACb,SAAS;EACT,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;6CAE6C;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,0EAA0E;AAC1E;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;;6CAE6C;AAC7C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,0CAA0C;EAC1C,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,iCAAiC;EACjC,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA,6DAA6D;AAC7D;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA,wFAAwF;AACxF;EACE,gCAAgC;EAChC,gCAAgC;EAChC,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA,+DAA+D;AAC/D;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,gBAAgB;EAChB,iCAAiC;EACjC,iCAAiC;EACjC,sCAAsC;EACtC,sCAAsC;EACtC,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,0CAA0C;EAC1C,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,4BAA4B;EAC5B,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,gCAAgC;EAChC,cAAc;EACd,qBAAqB;EACrB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,0CAA0C;EAC1C,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,0CAA0C;EAC1C,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,qBAAqB;EACrB,4BAA4B;EAC5B,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,qBAAqB;EACrB,iCAAiC;EACjC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,qBAAqB;EACrB,iCAAiC;EACjC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;6CAE6C;AAC7C,mCAAmC;AACnC,qCAAqC;;AAErC;;6CAE6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;6CAE6C;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;AACf;;AAEA,mEAAmE;AACnE;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;iGACiG;AACjG;EACE,iBAAiB;AACnB;;AAEA;;6CAE6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,2BAA2B;EAC3B,gCAAgC;EAChC,uCAAuC;EACvC,8CAA8C;EAC9C,0CAA0C;EAC1C,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,OAAO;EACP,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,gCAAgC;EAChC,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB;;mBAEiB;EACjB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,yDAAyD;EACzD,gEAAgE;AAClE;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,UAAU;EACV,0BAA0B;EAC1B,yBAAyB;EACzB,gCAAgC;EAChC,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB;;mBAEiB;EACjB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,yDAAyD;EACzD,gEAAgE;AAClE;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;;6CAE6C;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC;EAChC,aAAa;AACf;;AAEA,mEAAmE;AACnE;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,8CAA8C;EAC9C,sCAAsC;AACxC;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,6GAA6G;AAC7G;EACE,qBAAqB;EACrB,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;;6CAE6C;AAC7C;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,gCAAgC;EAChC,uCAAuC;EACvC,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,4CAA4C;EAC5C,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,4EAA4E;AAC9E;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;AAChB;;AAEA;AACA;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,OAAO;EACP,SAAS;EACT,oBAAoB;AACtB;;AAEA;;6CAE6C;AAC7C;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,0CAA0C;EAC1C,+BAA+B;EAC/B,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,yCAAyC;AACzC;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;6CAE6C;AAC7C;EACE,aAAa;EACb,OAAO;EACP,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;;AAEA,oDAAoD;AACpD;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,gCAAgC;EAChC,uCAAuC;EACvC,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,4CAA4C;EAC5C,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,oDAAoD;AACpD;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;;EAGE,oBAAoB;EACpB,qBAAqB;EACrB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;EAGE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;EAGE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,OAAO;EACP,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,yBAAyB;EACzB,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;6CAE6C;AAC7C;;uDAEuD;AACvD;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA,+CAA+C;AAC/C;EACE,sBAAsB;EACtB;;mBAEiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,+CAA+C;EAC/C,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oCAAoC;EACpC,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf;;oBAEkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,oCAAoC;EACpC,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,wEAAwE;AACxE;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mEAAmE;AACnE;EACE,yBAAyB;AAC3B;;AAEA,iEAAiE;AACjE;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;;6CAE6C;AAC7C;EACE;IACE,SAAS;IACT,2BAA2B;EAC7B;AACF;;AAEA;;6CAE6C;AAC7C;EACE,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;EAChC,0CAA0C;EAC1C,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,0BAA0B;EAC1B,WAAW;EACX,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA,sDAAsD;AACtD;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,0BAA0B;EAC1B,WAAW;EACX,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,cAAc;AAChB;;AAEA;2CAC2C;AAC3C;EACE,UAAU;EACV,MAAM;AACR;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/**\n * Irrigation System Monitoring - Figma Design Match\n * Colors and typography from Figma design tokens\n */\n\n/* ========================================\n   COLORS FROM FIGMA\n   ======================================== */\n:root {\n  --grey-100: #ffffff;\n  --grey-98: #f6f8fa;\n  --grey-96: #eef1f6;\n  --grey-91: #dce0e8;\n  --grey-80: #afb9cc;\n  --grey-71: #919db4;\n  --grey-52: #626e84;\n  --grey-45: #4d5674;\n  --grey-34: #3b4259;\n  --grey-25: #2a2f40;\n\n  --primary-idle: #4563c7;\n  --status-alert: #df3044;\n  --status-warning: #ffb302;\n  --status-positive: #078378;\n  --event-irrigation: #0a5ef0;\n\n  /* Typography */\n  --font-family: 'Source Sans Pro', sans-serif;\n}\n\n/* ========================================\n   LAYOUT\n   ======================================== */\n.irrigation-monitoring {\n  display: flex;\n  gap: 40px;\n  height: calc(100vh - 48px);\n  background-color: #eef1f6;\n  padding: 8px 40px 40px 40px;\n  overflow-x: hidden;\n}\n\n/* ========================================\n   LEFT PANEL - FIELD LIST\n   ======================================== */\n.leading-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  height: 100%;\n  overflow: hidden;\n  background: transparent;\n}\n\n.leading-panel.basic {\n  width: 400px;\n  min-width: 400px;\n  max-width: 400px;\n}\n\n.leading-panel.advanced {\n  flex: 1 1 auto;\n  min-width: 400px;\n  max-width: 1200px;\n  overflow: hidden;\n}\n\n/* In advanced mode, map takes remaining space with min-width constraint */\n.leading-panel.advanced + .trailing-panel-wrap {\n  flex: 1;\n  min-width: 520px;\n}\n\n/* ========================================\n   SELECTORS (Sort and Advanced/Close buttons)\n   ======================================== */\n.selectors {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 40px;\n  padding: 0px;\n  gap: 16px;\n  background: transparent;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-family: var(--font-family);\n  font-size: 14px;\n  line-height: 16px;\n  color: #3b4259;\n  color: var(--grey-34);\n  box-sizing: border-box;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  z-index: 2;\n  position: relative;\n}\n\n/* Sort button */\n.sort-button {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n  height: 40px;\n  padding: 4px 12px 4px 8px;\n  background-color: transparent;\n  border: none;\n  border-radius: 16px;\n  cursor: pointer;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-family: var(--font-family);\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 16px;\n  color: #626e84;\n  color: var(--grey-52);\n  transition: background-color 0.2s;\n  flex: none;\n}\n\n.sort-button:hover {\n  background-color: #eef1f6;\n  background-color: var(--grey-96);\n}\n\n.selector-icon {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n/* All Farm - Sort dropdown (Figma) */\n.all-farm-sort {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.all-farm-sort__button {\n  /* data manipulator */\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding: 4px 12px 4px 8px;\n  gap: 4px;\n  width: 92px;\n  height: 40px;\n  background: transparent;\n  border: none;\n  border-radius: 16px;\n  cursor: pointer;\n  color: var(--color-grey-45);\n  color: var(--color-grey-45);\n}\n\n.all-farm-sort__button:hover {\n  background: var(--color-grey-91);\n  background: var(--color-grey-91);\n}\n\n.all-farm-sort__button:active {\n  background: var(--color-grey-80);\n  background: var(--color-grey-80);\n}\n\n/* Crop water availability (Figma: active=off): grey shades */\n.all-farm-sort__button--crop-availability:hover {\n  background: var(--color-grey-91);\n  background: var(--color-grey-91);\n}\n\n.all-farm-sort__button--crop-availability:active {\n  background: var(--color-grey-80);\n  background: var(--color-grey-80);\n}\n\n/* After click (menu open): crop availability keeps hover appearance when mouse leaves */\n.all-farm-sort__button--open.all-farm-sort__button--crop-availability {\n  background: var(--color-grey-91);\n  background: var(--color-grey-91);\n  color: var(--color-grey-45);\n  color: var(--color-grey-45);\n}\n\n.all-farm-sort__button--open.all-farm-sort__button--crop-availability:hover {\n  background: var(--color-grey-91);\n  background: var(--color-grey-91);\n}\n\n.all-farm-sort__button--open.all-farm-sort__button--crop-availability:active {\n  background: var(--color-grey-80);\n  background: var(--color-grey-80);\n}\n\n/* Non-crop-availability sort (Figma: active=on): blue shades */\n.all-farm-sort__button--active {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.all-farm-sort__button--active:hover {\n  background: #bdd5ff;\n}\n\n.all-farm-sort__button--active:active {\n  background: #a8c8ff;\n}\n\n/* After click (menu open): non-crop keeps hover appearance when mouse leaves */\n.all-farm-sort__button--open.all-farm-sort__button--active {\n  background: #bdd5ff;\n}\n\n.all-farm-sort__button--open.all-farm-sort__button--active:hover {\n  background: #bdd5ff;\n}\n\n.all-farm-sort__button--open.all-farm-sort__button--active:active {\n  background: #a8c8ff;\n}\n\n.all-farm-sort__menu {\n  position: absolute;\n  top: calc(100% + 2px);\n  left: 0;\n  min-width: 240px;\n  background: var(--color-grey-100);\n  background: var(--color-grey-100);\n  border: 1px solid var(--color-grey-91);\n  border: 1px solid var(--color-grey-91);\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  padding: 8px;\n  z-index: 1000;\n}\n\n.all-farm-sort__menu-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n  padding: 10px 8px;\n  background: transparent;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  color: var(--color-grey-45);\n  color: var(--color-grey-45);\n  text-align: left;\n}\n\n.all-farm-sort__menu-item:hover {\n  background: var(--color-grey-96);\n  background: var(--color-grey-96);\n}\n\n.all-farm-sort__menu-item--selected {\n  background: var(--color-grey-98);\n  background: var(--color-grey-98);\n}\n\n.all-farm-sort__menu-item-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.all-farm-sort__menu-check {\n  width: 16px;\n  height: 16px;\n  color: var(--color-grey-45);\n  color: var(--color-grey-45);\n  opacity: 0;\n}\n\n.all-farm-sort__menu-check--visible {\n  opacity: 1;\n}\n\n.all-farm-sort__menu-item-label {\n  color: inherit;\n}\n\n/* Sort and Group buttons container */\n.sort-and-group-wrap {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n/* Individual selector item (Sort, Group) */\n.selector-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: transparent;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-family: var(--font-family);\n  font-size: 14px;\n  font-weight: 600;\n  color: #626e84;\n  color: var(--grey-52);\n  transition: background-color 0.2s;\n}\n\n.selector-item:hover {\n  background-color: #eef1f6;\n  background-color: var(--grey-96);\n}\n\n.selector-icon {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n/* Advanced/Close button */\n.button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  height: 40px;\n  padding-left: 22px;\n  padding-right: 16px;\n  background-color: transparent;\n  border: 1px solid #919db4;\n  border: 1px solid var(--grey-71);\n  border-radius: 16px;\n  cursor: pointer;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-family: var(--font-family);\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 16px;\n  color: #4d5674;\n  color: var(--grey-45);\n  text-decoration: none;\n  transition: all 0.2s;\n  white-space: nowrap;\n  flex: none;\n  overflow: hidden;\n  max-width: 100%;\n}\n\n.button.minimized {\n  background-color: transparent;\n  border-color: #919db4;\n  border-color: var(--grey-71);\n  color: #4d5674;\n  color: var(--grey-45);\n  padding-left: 22px;\n  padding-right: 16px;\n}\n\n.button.expanded {\n  background-color: transparent;\n  border: 1px solid #919db4;\n  border: 1px solid var(--grey-71);\n  color: #4d5674;\n  color: var(--grey-45);\n  padding: 0px 24px 0px 16px;\n  width: 98px;\n}\n\n.button:hover {\n  background-color: var(--color-grey-98);\n  background-color: var(--color-grey-98);\n}\n\n.button:active {\n  background-color: var(--color-grey-91);\n  background-color: var(--color-grey-91);\n}\n\n.button svg {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n/* DEPRECATED: Old classes - kept for backward compatibility */\n.header-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 16px;\n  background-color: transparent;\n}\n\n.sort-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background-color: transparent;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-family: var(--font-family);\n  font-size: 14px;\n  font-weight: 600;\n  color: #626e84;\n  color: var(--grey-52);\n  transition: background-color 0.2s;\n}\n\n.sort-button:hover {\n  background-color: #eef1f6;\n  background-color: var(--grey-96);\n}\n\n.sort-button svg {\n  width: 20px;\n  height: 20px;\n  stroke: #626e84;\n  stroke: var(--grey-52);\n}\n\n.toggle-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background-color: transparent;\n  border: 1px solid #dce0e8;\n  border: 1px solid var(--grey-91);\n  border-radius: 4px;\n  cursor: pointer;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-family: var(--font-family);\n  font-size: 14px;\n  font-weight: 600;\n  color: #4d5674;\n  color: var(--grey-45);\n  transition: all 0.2s;\n  min-width: 100px;\n  justify-content: center;\n}\n\n.toggle-button:hover {\n  background-color: #eef1f6;\n  background-color: var(--grey-96);\n  border-color: #afb9cc;\n  border-color: var(--grey-80);\n}\n\n.toggle-button.advanced-mode {\n  background-color: #ffffff;\n  background-color: var(--grey-100);\n  border-color: #dce0e8;\n  border-color: var(--grey-91);\n  color: #4d5674;\n  color: var(--grey-45);\n}\n\n.toggle-button.close-mode {\n  background-color: #df3044;\n  background-color: var(--status-alert);\n  border-color: #df3044;\n  border-color: var(--status-alert);\n  color: #ffffff;\n  color: var(--grey-100);\n}\n\n.toggle-button.close-mode:hover {\n  background-color: #c72838;\n  border-color: #c72838;\n}\n\n.toggle-button svg {\n  width: 16px;\n  height: 16px;\n}\n\n.button.close-mode {\n  background-color: #df3044;\n  background-color: var(--status-alert);\n  border-color: #df3044;\n  border-color: var(--status-alert);\n  color: #ffffff;\n  color: var(--grey-100);\n}\n\n.button.close-mode:hover {\n  background-color: #c72838;\n  border-color: #c72838;\n}\n\n/* ========================================\n   DEPRECATED SECTIONS (kept for reference)\n   ======================================== */\n/* Location Breadcrumbs - REMOVED */\n/* Selectors (Sort/Group) - REMOVED */\n\n/* ========================================\n   ACTION BAR (DEPRECATED - kept for compatibility)\n   ======================================== */\n.table-action-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 40px;\n}\n\n.data-manipulators {\n  display: flex;\n  gap: 8px;\n}\n\n.data-manipulator {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px 4px 12px;\n  background: transparent;\n  border: none;\n  border-radius: 16px;\n  cursor: pointer;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-family: var(--font-family);\n  font-size: 16px;\n  font-weight: 600;\n  color: #626e84;\n  color: var(--grey-52);\n  transition: background-color 0.2s;\n}\n\n.data-manipulator:hover {\n  background-color: var(--color-grey-98);\n  background-color: var(--color-grey-98);\n}\n\n.advanced-toggle-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  height: 40px;\n  padding: 0 16px;\n  background: transparent;\n  border: 1px solid #919db4;\n  border: 1px solid var(--grey-71);\n  border-radius: 16px;\n  cursor: pointer;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-family: var(--font-family);\n  font-size: 16px;\n  font-weight: 600;\n  color: #4d5674;\n  color: var(--grey-45);\n  transition: all 0.2s;\n}\n\n.advanced-toggle-button:hover {\n  background-color: var(--color-grey-98);\n  background-color: var(--color-grey-98);\n}\n\n.advanced-toggle-button.advanced-mode {\n  padding-left: 24px;\n}\n\n.advanced-toggle-button.close-mode {\n  padding-right: 24px;\n}\n\n/* ========================================\n   TABLE\n   ======================================== */\n.fields-table {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  background: #ffffff;\n  background: var(--grey-100);\n  border: 1px solid #dce0e8;\n  border: 1px solid var(--grey-91);\n  border-radius: 16px;\n  overflow: hidden;\n  min-height: 0;\n}\n\n/* Scroll wrapper - handles horizontal scrolling in advanced mode */\n.fields-table-scroll {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\n/* In advanced mode, enable horizontal scrolling inside the table */\n.leading-panel.advanced .fields-table-scroll {\n  overflow-x: auto;\n  min-width: 0;\n}\n\n/* Minimum width to display all advanced mode columns without wrapping:\n   trigger-area (48px) + basic-section (328px) + gap (24px) + advanced-section (611px) ≈ 1016px */\n.leading-panel.advanced .fields-table-scroll > * {\n  min-width: 1016px;\n}\n\n/* ========================================\n   TABLE HEADER\n   ======================================== */\n.table-header {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  height: 72px;\n  padding: 0px 16px 0px 48px;\n  background: #ffffff;\n  background: var(--grey-100);\n  border-bottom: 1px solid #dce0e8;\n  border-bottom: 1px solid var(--grey-91);\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);\n  font-family: 'Source Sans Pro', sans-serif;\n  font-family: var(--font-family);\n  font-size: 14px;\n  font-weight: 600;\n  color: #3b4259;\n  color: var(--grey-34);\n  line-height: 16px;\n  overflow: visible;\n  position: relative;\n  z-index: 1;\n}\n\n.basic-columns {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  flex: 1;\n}\n\n.advanced-columns {\n  display: flex;\n  flex: 1;\n  gap: 40px;\n  align-items: center;\n}\n\n.header-cell {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.field-name-header {\n  width: 216px;\n}\n\n.status-header {\n  width: 96px;\n}\n\n.recommendation-header {\n  width: 120px;\n}\n\n.performance-header {\n  flex: 1;\n  min-width: 120px;\n  justify-content: flex-start;\n}\n\n.performance-header > span {\n  flex: 0 0 auto;\n  max-width: 80px;\n  word-wrap: break-word;\n  text-align: left;\n}\n\n.cbar-header > span {\n  flex: 0 0 auto;\n  max-width: 60px;\n  word-wrap: break-word;\n  text-align: left;\n}\n\n.irrigation-header {\n  width: 112px;\n}\n\n.irrigation-header > span {\n  flex: 0 0 auto;\n  max-width: 65px;\n  word-wrap: break-word;\n  text-align: left;\n}\n\n.cbar-header {\n  flex: 1;\n  min-width: 160px;\n}\n\n.info-icon {\n  flex-shrink: 0;\n}\n\n/* Info icon tooltip wrapper */\n.info-icon-wrapper {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.info-tooltip {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #4d5674;\n  background-color: var(--grey-45);\n  color: #ffffff;\n  color: var(--grey-100);\n  padding: 5px 8px;\n  border-radius: 2px;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.4;\n  width: 240px;\n  white-space: normal;\n  text-align: left;\n  z-index: 99999;\n  opacity: 0;\n  visibility: hidden;\n  transition:\n    opacity 0.2s,\n    visibility 0.2s;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  pointer-events: none;\n}\n\n.info-tooltip::before {\n  content: '';\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border-width: 6px;\n  border-style: solid;\n  border-color: transparent transparent #4d5674 transparent;\n  border-color: transparent transparent var(--grey-45) transparent;\n}\n\n.info-icon-wrapper:hover .info-tooltip {\n  opacity: 1;\n  visibility: visible;\n}\n\n/* Clock icon tooltip wrapper for transmitter update */\n.clock-icon-wrapper {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.clock-tooltip {\n  position: absolute;\n  bottom: calc(100% + 8px);\n  right: 50%;\n  transform: translateX(50%);\n  background-color: #4d5674;\n  background-color: var(--grey-45);\n  color: #ffffff;\n  color: var(--grey-100);\n  padding: 6px 10px;\n  border-radius: 2px;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.4;\n  white-space: nowrap;\n  text-align: center;\n  z-index: 99999;\n  opacity: 0;\n  visibility: hidden;\n  transition:\n    opacity 0.2s,\n    visibility 0.2s;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  pointer-events: none;\n}\n\n.clock-tooltip::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border-width: 6px;\n  border-style: solid;\n  border-color: #4d5674 transparent transparent transparent;\n  border-color: var(--grey-45) transparent transparent transparent;\n}\n\n.clock-icon-wrapper:hover .clock-tooltip {\n  opacity: 1;\n  visibility: visible;\n}\n\n/* ========================================\n   FIELD LIST\n   ======================================== */\n.field-list {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  border-bottom-left-radius: 16px;\n  border-bottom-right-radius: 16px;\n  min-height: 0;\n}\n\n/* Custom scrollbar styling - hidden by default, visible on hover */\n.field-list::-webkit-scrollbar {\n  width: 8px;\n}\n\n.field-list::-webkit-scrollbar-track {\n  background: transparent;\n  border-radius: 4px;\n}\n\n.field-list::-webkit-scrollbar-thumb {\n  background-color: transparent;\n  border-radius: 4px;\n  border: 2px solid transparent;\n  background-clip: padding-box;\n  -webkit-transition: background-color 0.2s ease;\n  transition: background-color 0.2s ease;\n}\n\n/* Show scrollbar on hover */\n.field-list:hover::-webkit-scrollbar-thumb {\n  background-color: #afb9cc;\n  background-color: var(--grey-80);\n}\n\n.field-list::-webkit-scrollbar-thumb:hover {\n  background-color: #919db4;\n  background-color: var(--grey-71);\n}\n\n/* Firefox scrollbar styling - always visible (Firefox doesn't support hover-based scrollbar color changes) */\n.field-list {\n  scrollbar-width: thin;\n  scrollbar-color: #afb9cc transparent;\n  scrollbar-color: var(--grey-80) transparent;\n}\n\n/* ========================================\n   FIELD ROW\n   ======================================== */\n.field-row {\n  position: relative;\n  display: flex;\n  align-items: center;\n  height: 88px;\n  min-height: 88px;\n  padding: 16px 0;\n  background: #ffffff;\n  background: var(--grey-100);\n  border-bottom: 1px solid #dce0e8;\n  border-bottom: 1px solid var(--grey-91);\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.field-row:hover {\n  background-color: var(--color-grey-98);\n  background-color: var(--color-grey-98);\n}\n\n.field-row.selected {\n  background-color: #f0f4ff;\n  outline: 2px solid var(--color-primary-idel);\n  outline: 2px solid var(--color-primary-idel);\n  outline-offset: -2px;\n  border-radius: 8px;\n}\n\n/* Field row settings menu on hover */\n.field-row-settings {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding-right: 4px;\n  pointer-events: auto;\n}\n\n.field-row-settings .dropdown {\n  position: relative;\n  z-index: 1;\n}\n\n.field-row-settings__icon {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  background: linear-gradient(90deg, rgba(246, 248, 250, 0) 0%, #f6f8fa 37.5%);\n}\n\n.field-row-settings__icon:hover {\n  background-color: var(--color-grey-96);\n  background-color: var(--color-grey-96);\n}\n\n.field-row-settings__icon:active {\n  background-color: var(--color-grey-91);\n  background-color: var(--color-grey-91);\n}\n\n.field-row-settings__menu-portal {\n  position: fixed;\n  top: var(--menu-top);\n  top: var(--menu-top);\n  left: var(--menu-left);\n  left: var(--menu-left);\n  z-index: 1000;\n}\n\n/* Alert trigger area */\n.trigger-area {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  flex-shrink: 0;\n}\n\n.alert-icon {\n}\n\n/* Main content */\n.main-content {\n  display: flex;\n  flex: 1;\n  gap: 24px;\n  align-items: stretch;\n}\n\n/* ========================================\n   BASIC SECTION (always visible)\n   ======================================== */\n.basic-section {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  flex: 1;\n}\n\n.name-and-crop {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  width: 216px;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-family: var(--font-family);\n  color: #3b4259;\n  color: var(--grey-34);\n  line-height: 16px;\n}\n\n.field-name {\n  font-size: 16px;\n  font-weight: 700;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  word-break: break-word;\n  line-height: 1.3;\n  max-height: calc(1.3em * 2);\n}\n\n.crop-type {\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.status-wrap {\n  display: flex;\n  align-items: center;\n  width: 96px;\n}\n\n.crop-water-availability-status {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 72px;\n  padding: 4px 6px;\n  border-radius: 4px;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-family: var(--font-family);\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 16px;\n}\n\n/* Hide advanced sections in basic mode */\n.table-header.basic .advanced-columns {\n  display: none;\n}\n\n.field-row:not(.advanced-mode) {\n  overflow: hidden;\n}\n\n.field-row:not(.advanced-mode) .advanced-section {\n  visibility: hidden;\n  position: absolute;\n  pointer-events: none;\n}\n\n/* ========================================\n   ADVANCED SECTION\n   ======================================== */\n.advanced-section {\n  display: flex;\n  flex: 1;\n  gap: 40px;\n  align-items: center;\n  width: 611px;\n}\n\n/* In advanced mode, field row has specific sizing */\n.field-row.advanced-mode {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 16px 16px 16px 0px;\n  width: auto;\n  height: 88px;\n  min-height: 88px;\n  background: #ffffff;\n  background: var(--grey-100);\n  border-bottom: 1px solid #dce0e8;\n  border-bottom: 1px solid var(--grey-91);\n  border-radius: 0px;\n  flex: none;\n  align-self: stretch;\n  flex-grow: 0;\n}\n\n.field-row.advanced-mode:hover {\n  background-color: var(--color-grey-98);\n  background-color: var(--color-grey-98);\n}\n\n.field-row.advanced-mode.selected {\n  background-color: #f0f4ff;\n  outline: 2px solid var(--color-primary-idel);\n  outline: 2px solid var(--color-primary-idel);\n  outline-offset: -2px;\n  border-radius: 8px;\n}\n\n/* In advanced mode, basic section has fixed width */\n.field-row.advanced-mode .basic-section {\n  width: 328px;\n  flex: none;\n}\n\n.table-header.advanced .basic-columns {\n  width: 328px;\n  flex: none;\n}\n\n.table-header.advanced .advanced-columns {\n  width: 611px;\n}\n\n.cell {\n  display: flex;\n  align-items: center;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-family: var(--font-family);\n  font-size: 14px;\n  font-weight: 600;\n  color: #3b4259;\n  color: var(--grey-34);\n  line-height: 16px;\n}\n\n/* Recommendation Cell */\n.recommendation-cell {\n  width: 120px;\n  padding: 8px 8px 8px 0;\n}\n\n.recommendation-amount .value-with-unit,\n.actual-value .value-with-unit,\n.planned-value .value-with-unit {\n  display: inline-flex;\n  align-items: flex-end;\n  height: 16px;\n  gap: 1px;\n}\n\n.value-with-unit .unit-wrap {\n  height: 14px;\n  display: flex;\n  align-items: flex-end;\n}\n\n.value-with-unit .unit-wrap--inch {\n  align-items: center;\n}\n\n.value-with-unit .unit--inch {\n  transform: translateY(-1px);\n}\n\n.recommendation-amount .value,\n.actual-value .value,\n.planned-value .value {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 16px;\n}\n\n.recommendation-amount .value,\n.actual-value .value {\n  color: #3b4259;\n  color: var(--grey-34);\n}\n\n.recommendation-amount .unit,\n.actual-value .unit,\n.planned-value .unit {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 12px;\n}\n\n.recommendation-amount .unit,\n.actual-value .unit {\n  color: #3b4259;\n  color: var(--grey-34);\n}\n\n.recommendation-amount .frequency {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 16px;\n  color: #3b4259;\n  color: var(--grey-34);\n}\n\n/* Performance Cell */\n.performance-cell {\n  flex: 1;\n  min-width: 120px;\n}\n\n/* Not available text for fields without weekly planner support */\n.not-available-text {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 16px;\n  letter-spacing: 0%;\n  color: var(--color-disabled-64);\n  color: var(--color-disabled-64);\n}\n\n.performance-indicator {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 100%;\n  height: 56px;\n  justify-content: center;\n  position: relative;\n}\n\n.actual-value {\n  display: flex;\n  align-items: flex-end;\n  gap: 1px;\n  width: 53px;\n}\n\n.rail {\n  display: flex;\n  height: 8px;\n  width: 100%;\n  background-color: #dce0e8;\n  background-color: var(--grey-91);\n  border-radius: 24px;\n  overflow: hidden;\n}\n\n.actual-indicator {\n  height: 100%;\n  background-color: #3b4259;\n  background-color: var(--grey-34);\n  border-radius: 80px;\n  transition: width 0.3s ease;\n}\n\n.planned-wrap {\n  position: absolute;\n  left: 75%;\n  bottom: 14px;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  height: 28px;\n}\n\n.planned-value {\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n}\n\n.planned-value .value {\n  color: #626e84;\n  color: var(--grey-52);\n}\n\n.planned-value .unit {\n  color: #626e84;\n  color: var(--grey-52);\n}\n\n.planned-indicator {\n  width: 2px;\n  flex: 1;\n  background-color: #919db4;\n  background-color: var(--grey-71);\n}\n\n/* Irrigation Cell */\n.irrigation-cell {\n  width: 112px;\n  gap: 5px;\n  padding: 2px 0;\n}\n\n.irrigation-content {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.irrigation-time {\n  font-size: 14px;\n  font-weight: 600;\n  color: #3b4259;\n  color: var(--grey-34);\n}\n\n.irrigation-duration {\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--grey-62);\n  color: var(--grey-62);\n}\n\n.active-irrigation-indicator {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px 4px 8px;\n  background-color: #0a5ef0;\n  background-color: var(--event-irrigation);\n  border-radius: 24px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #ffffff;\n  color: var(--grey-100);\n  line-height: 12px;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n\n.irrigation-status-blinker {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.irrigation-status-blinker .indicator {\n  width: 8px;\n  height: 8px;\n  background-color: #ffffff;\n  background-color: var(--grey-100);\n  border-radius: 50%;\n  animation: blink 1.5s infinite;\n}\n\n@keyframes blink {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.3;\n  }\n}\n\n.time-icon {\n  flex-shrink: 0;\n}\n\n/* CBar Cell */\n.cbar-cell {\n  flex: 1;\n  min-width: 160px;\n}\n\n.cbar-content {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.cbar-graph-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n}\n\n.water-potential-graph {\n  height: 40px;\n}\n\n.start-date {\n  font-size: 12px;\n  font-weight: 600;\n  color: #626e84;\n  color: var(--grey-52);\n  line-height: 12px;\n}\n\n.current-cbar {\n  font-size: 14px;\n  font-weight: 600;\n  color: #3b4259;\n  color: var(--grey-34);\n  text-align: right;\n  width: 24px;\n}\n\n.cbar-no-data {\n  font-size: 14px;\n  font-weight: 500;\n  color: #919db4;\n  color: var(--grey-71);\n  text-align: left;\n  width: 100%;\n}\n\n/* ========================================\n   RIGHT PANEL - MAP\n   ======================================== */\n/* Wrapper hosts the toggle (sits above the white frame) and the panel.\n   Mirrors the leading-panel's 40px header + 8px gap so the white\n   frames on both sides start at the same Y position. */\n.trailing-panel-wrap {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  min-width: 400px;\n  height: 100%;\n  gap: 8px;\n}\n\n.trailing-panel {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  min-width: 400px;\n  height: 100%;\n  background: #ffffff;\n  background: var(--grey-100);\n  border: 1px solid #dce0e8;\n  border: 1px solid var(--grey-91);\n  border-radius: 16px;\n  overflow: hidden;\n  padding: 40px;\n  gap: 16px;\n}\n\n/* Farm map / Field details segmented control */\n.trailing-panel__tabs {\n  box-sizing: border-box;\n  /* Two equal columns sized by the longer label: 240px (Figma) in English,\n     wider for longer translations (e.g. pt \"Detalhes do campo\") instead of\n     overflowing. */\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  align-self: center;\n  align-items: center;\n  gap: 2px;\n  width: -moz-max-content;\n  width: max-content;\n  min-width: 240px;\n  max-width: 100%;\n  height: 40px;\n  padding: 4px;\n  background: #ffffff;\n  border: 1px solid #dce0e8;\n  border: 1px solid var(--color-grey-91, #dce0e8);\n  border-radius: 16px;\n  flex: none;\n}\n\n.trailing-panel__tab {\n  flex: 1;\n  height: 32px;\n  padding: 8px 12px;\n  border: none;\n  border-radius: 12px;\n  background: transparent;\n  color: #4d5674;\n  color: var(--color-grey-45, #4d5674);\n  font-family: 'Source Sans Pro', sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 16px;\n  white-space: nowrap;\n  cursor: pointer;\n  transition:\n    background-color 0.15s ease,\n    color 0.15s ease;\n}\n\n.trailing-panel__tab:hover:not(.trailing-panel__tab--selected) {\n  background: #eef1f6;\n  background: var(--color-grey-96, #eef1f6);\n}\n\n.trailing-panel__tab--selected {\n  background: #4d5674;\n  background: var(--color-grey-45, #4d5674);\n  color: #ffffff;\n}\n\n.trailing-panel__details {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  position: relative;\n  z-index: 0;\n  background: transparent;\n}\n\n.trailing-panel__details-empty {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 24px;\n  color: #919db4;\n  color: var(--color-grey-71, #919db4);\n  font-family: 'Source Sans Pro', sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.map-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  border: 1px solid #dce0e8;\n  border: 1px solid var(--grey-91);\n  border-radius: 8px;\n  overflow: hidden;\n  position: relative;\n  z-index: 0;\n}\n\n/* Hide NDVI timeline/legend by default - only show when explicitly on */\n.map-container .map-legend {\n  display: none !important;\n}\n\n.map-container.ndvi-on .map-legend {\n  display: block !important;\n}\n\n/* Show map control buttons (zoom, home, layers) - always visible */\n.map-container .leaflet-control-container .map-legend {\n  display: block !important;\n}\n\n/* Override Leaflet default 10px margin to 8px for map controls */\n.map-container .leaflet-top .leaflet-control {\n  margin-top: 8px;\n}\n.map-container .leaflet-bottom .leaflet-control {\n  margin-bottom: 8px;\n}\n.map-container .leaflet-left .leaflet-control {\n  margin-left: 8px;\n}\n.map-container .leaflet-right .leaflet-control {\n  margin-right: 8px;\n}\n\n/* ========================================\n   RESPONSIVE\n   ======================================== */\n@media (max-width: 1439px) {\n  .irrigation-monitoring {\n    gap: 24px;\n    padding: 8px 24px 24px 24px;\n  }\n}\n\n/* ========================================\n   ALERT TOOLTIP\n   ======================================== */\n.alert-tooltip {\n  position: fixed;\n  background: #ffffff;\n  background: var(--grey-100);\n  border-radius: 10px;\n  border: 1px solid #dce0e8;\n  border: 1px solid var(--grey-91);\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);\n  z-index: 1001;\n  width: 380px;\n  max-height: 480px;\n  overflow: visible;\n}\n\n/* Arrow border (grey-91) */\n.alert-tooltip::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  top: var(--arrow-top, 50%);\n  left: -16px;\n  transform: translateY(-50%);\n  width: 16px;\n  height: 24px;\n  background: #dce0e8;\n  background: var(--grey-91);\n  clip-path: polygon(100% 0, 0 50%, 100% 100%);\n}\n\n/* Arrow fill (white, inset by 1px to reveal border) */\n.alert-tooltip::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  top: var(--arrow-top, 50%);\n  left: -14px;\n  transform: translateY(-50%);\n  width: 14px;\n  height: 22px;\n  background: #ffffff;\n  background: var(--grey-100);\n  clip-path: polygon(100% 0, 0 50%, 100% 100%);\n}\n\n.alert-tooltip-list {\n  overflow-y: auto;\n  max-height: 480px;\n  padding: 24px;\n  border-radius: 10px;\n}\n\n/* Constrain NotificationItem content inside tooltip */\n.alert-tooltip-list .alert_div {\n  overflow: hidden;\n}\n\n.alert-tooltip-list .alert_div:last-child {\n  border-bottom: none !important;\n}\n\n.alert-tooltip-list .alert_div > div:last-child {\n  overflow: hidden;\n  min-width: 0;\n  flex: 1;\n}\n\n.alert-tooltip-list .read-more-pill {\n  flex-shrink: 0;\n}\n\n/* Field details tab: the tab lays itself out (header + scrolling body), so\n   the panel drops the map tab's padding. */\n.trailing-panel.trailing-panel--details {\n  padding: 0;\n  gap: 0;\n}\n\n.trailing-panel--details .trailing-panel__details {\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
